import SyPopup from "./sy-modal";

export default SyPopup;